import { Stack, ActionIcon } from '@mantine/core';
import { OrganizationContact } from '@medplum/fhirtypes';
import { IconPlus } from '@tabler/icons-react';
import { useState } from 'react';
import { CreatePartnerContactCard } from '../CreatePartnerContactCard';
import { PartnerContactCard } from '../PartnerContactCard';
import { ExpandableCard } from '@/components/ExpandableCard';

export function PartnerContactsSection({
  contacts,
  onChange,
  onAdd,
  draftContacts = [],
  onDraftContactsChange,
}: {
  contacts: OrganizationContact[];
  onChange: (contacts: OrganizationContact[]) => void;
  onAdd?: (newContact: OrganizationContact) => void;
  draftContacts?: OrganizationContact[];
  onDraftContactsChange?: (contacts: OrganizationContact[]) => void;
}) {
  const [addingNew, setAddingNew] = useState(false);

  return (
    <ExpandableCard
      title="Contacts"
      action={
        <ActionIcon
          variant="light"
          size="xs"
          onClick={(e) => {
            e.stopPropagation();
            setAddingNew(true);
          }}
          aria-label="Add contact"
        >
          <IconPlus size={16} />
        </ActionIcon>
      }
    >
      <Stack gap="md">
        {addingNew && (
          <CreatePartnerContactCard
            onCreate={(newContact) => {
              setAddingNew(false);
              if (onDraftContactsChange) {
                const updatedDrafts = [...draftContacts, newContact];
                onDraftContactsChange(updatedDrafts);
              } else {
                onAdd?.(newContact);
              }
            }}
            onCancel={() => {
              setAddingNew(false);
            }}
          />
        )}
        {/* Render existing persisted contacts */}
        {contacts.map((contact, index) => (
          <PartnerContactCard
            key={`contact-${index}`}
            contact={contact}
            onDelete={() => {
              const updatedContacts = contacts.filter((_, i) => i !== index);
              onChange(updatedContacts);
            }}
            onChange={(updatedContact) => {
              const newContacts = contacts.map((c, i) => (i === index ? updatedContact : c));
              onChange(newContacts);
            }}
          />
        ))}
        {/* Render draft contacts (not yet persisted) */}
        {draftContacts.map((contact, index) => (
          <PartnerContactCard
            key={`draft-${index}`}
            contact={contact}
            onDelete={() => {
              const updatedDrafts = draftContacts.filter((_, i) => i !== index);
              onDraftContactsChange?.(updatedDrafts);
            }}
            onChange={(updatedContact) => {
              const updatedDrafts = draftContacts.map((c, i) => (i === index ? updatedContact : c));
              onDraftContactsChange?.(updatedDrafts);
            }}
          />
        ))}
      </Stack>
    </ExpandableCard>
  );
}
